import { render, staticRenderFns } from "./reportcard.vue?vue&type=template&id=e95fbe78&"
import script from "./reportcard.vue?vue&type=script&lang=js&"
export * from "./reportcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports